/**
 * Resolves the localized body text shown by `PlaceholderErrorModal`
 * when a batched fetch fails across features (e.g. PropertyShow, TradeList).
 * The `queryType` is tagged onto the thrown error by `BatchQueryError`, and
 * this helper maps that tag to a feature-specific localized message. The
 * fallback itself is feature-agnostic; each feature supplies its own
 * `messages` lookup so the appropriate vocabulary stays within its own tree.
 * @param {object} intl - The react-intl `IntlShape` from `useIntl()`.
 * @param {object} messages - A lookup keyed by query-type string to
 *   react-intl message descriptors. Corresponds to either
 *   `PROPERTY_SHOW_QUERY_TYPES` or `TRADE_LIST_QUERY_TYPES` depending on
 *   the calling feature.
 * @param {string|null} queryType - The `queryType` value carried by a
 *   `BatchQueryError` (e.g. a member of `PROPERTY_SHOW_QUERY_TYPES` or
 *   `TRADE_LIST_QUERY_TYPES`), or null when the failure has no associated
 *   query type.
 * @returns {string|null} The localized body message, or null when
 *   `queryType` is null or not in the lookup (callers should pass null to
 *   `PlaceholderErrorModal` so its underlying modal renders its
 *   default body).
 */
export default function formatAsyncErrorBodyText(intl, messages, queryType) {
  if (!queryType || !messages[queryType]) return null;
  return intl.formatMessage(messages[queryType]);
}
